module.exports = __webpack_public_path__ + "img/geofisica_3-4_512.8a7a76fc.webp";